import { useCallback } from 'react';
import { useQueryClient } from '../../lib';
import { getMemberKey, getMembersKey } from '../../utils/keys';
export const useInvalidateMemberQuery = () => {
    const queryClient = useQueryClient();
    const invalidate = useCallback((memberId) => {
        const memberKey = getMemberKey({ variables: { id: memberId } });
        queryClient.invalidateQueries(memberKey);
        const membersKey = getMembersKey();
        queryClient.invalidateQueries(membersKey);
    }, [queryClient]);
    return invalidate;
};
//# sourceMappingURL=useInvalidateMemberQuery.js.map